<template>
	<div class="Affiches_case">
		<vue-headful
				description=""
				title="Slumberland | Créations affiches"
		/>
		<CaseTop
				cover="Affiches_cover.jpg"
				protectHeader="true"
				title="Créations affiches"
		/>
		<ImageSingle
				affiche="true"
				bgColor="#2e338d"
				firstAffiche="true"
				image="Affiches_001.jpg"
				legende="Pour l’association Au&#8209;delà&nbsp;de&nbsp;l’Écran et la Marie de Vincennes"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#ffffff"
				image="Affiches_002.jpg"
				legende="Pour le Public Système Cinéma"
				light="false"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#162567"
				image="Affiches_003.jpg"
				legende="Pour le Public Système Cinéma"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#000000"
				image="Affiches_004.jpg"
				legende="Pour le Public Système Cinéma"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#df0613"
				image="Affiches_005.jpg"
				legende="Pour le Public Système Cinéma"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#feca30"
				image="Affiches_006.jpg"
				legende="Pour le Public Système Cinéma"
				light="false"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#00aab5"
				image="Affiches_007.jpg"
				legende="Pour Coin de Mire Cinéma"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#000000"
				image="Affiches_008.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#00aab5"
				image="Affiches_009.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#feca30"
				image="Affiches_010.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#ffffff"
				image="Affiches_011.jpg"
				legende="Pour e-cinema.com"
				light="false"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#000000"
				image="Affiches_012.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#feca30"
				image="Affiches_013.jpg"
				legende="Pour e-cinema.com"
				light="false"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#2e338d"
				image="Affiches_014.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#feca30"
				image="Affiches_015.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#162567"
				image="Affiches_016.jpg"
				legende="Pour e-cinema.com"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#000000"
				image="Affiches_017.jpg"
				legende="Pour Salut Ô Productions"
		>
		</ImageSingle>
		<ImageSingle
				affiche="true"
				bgColor="#df0613"
				image="Affiches_018.jpg"
				legende="Pour la Mairie de Vincennes"
		>
		</ImageSingle>
		<CaseNext
				page="Société Générale"
		>
		</CaseNext>
	</div>


</template>

<script>

import CaseNext from "@/components/CaseNext.vue";
import CaseTop from "@/components/CaseTop.vue";
import ImageSingle from "@/components/ImageSingle.vue";
import $ from "jquery";

export default {
	name: "CaseAffiches",
	components: {
		CaseTop, ImageSingle, CaseNext
	},
	data() {
		return {};
	},
	mounted: function () {
		$("#app").addClass("noSticky");
	},
	destroyed: function () {
		$("#app").removeClass("noSticky");
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


</style>
